import Head from 'next/head';
import css from 'styled-jsx/css';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import user from '../../src/services/api/user';
import { baseUrlOf } from '../../src/lib/ssr';
import { api } from '../../src/lib/prismic';

import Header from '../../src/components/common/Header';
import Footer from '../../src/components/common/Footer';
import Assurance from '../../src/components/assurance/Assurance';
import SupportForm from '../../src/components/common/elements/SupportForm';

const footerImageHeight = 149;

const footerStyles = css.resolve`
  .insurance-footer {
    margin-top: ${footerImageHeight + 60}px;
  }

  .insurance-footer::before {
    position: absolute;
    width: 100%;
    height: ${footerImageHeight}px;
    top: -${footerImageHeight}px;
    background: url('/static/images/monuments.svg');
    content: '';
  }
`;

const TITLE = "YUPWEGO - L'assurance dont vous êtes le héros";
const DESCRIPTION = `YUPWEGO l’assurance voyage flexible qui s’adapte vraiment à vous`;
const HREF = '/assurance';

const Index = ({ profile, currentUrl, content }) => {
  return (
    <>
      <Head>
        <title key="title">{TITLE}</title>
        <meta key="description" content={DESCRIPTION} property="description" />
        <meta key="og:type" content="page" property="og:type" />
        <meta key="og:title" content={TITLE} property="og:title" />
        <meta
          key="og:description"
          content={DESCRIPTION}
          property="og:description"
        />
        <meta key="og:url" content={currentUrl} property="og:url" />
        <meta key="twitter:card" name="twitter:card" content="summary" />
        <meta key="twitter:title" name="twitter:title" content={TITLE} />
        <meta
          key="twitter:description"
          name="twitter:description"
          content={DESCRIPTION}
        />
      </Head>
      <Header profile={profile} />
      <Assurance content={content} />
      <SupportForm />
      <Footer
        className={classnames('insurance-footer', footerStyles.className)}
      />
      {footerStyles.styles}
    </>
  );
};

Index.getInitialProps = async ({ req, res }) => {
  const profile = await user.profile(req, res);
  const currentUrl = `${baseUrlOf(req)}/assurance`;
  const prismicApi = await api();
  const prismicData = await prismicApi.getSingle('insurance', {
    lang: 'fr-fr'
  });
  const content = prismicData.data;
  return {
    profile,
    currentUrl,
    content
  };
};

Index.propTypes = {
  content: PropTypes.object.isRequired,
  currentUrl: PropTypes.string.isRequired,
  profile: PropTypes.oneOfType([PropTypes.object, PropTypes.bool]).isRequired
};

export default Index;
export { HREF };
